// extracted by mini-css-extract-plugin
export default {"vehicles":"Dependent_vehicles__CFpXD","header":"Dependent_header__ojWgX"};